var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMijnStadGemeente(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199.9 155.7",
    style: {
      enableBackground: "new 0 0 199.9 155.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1E93D2;}\r\n\t.st1{display:none;fill:#868686;}\r\n\t.st2{fill:#868686;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Marker_00000031185075544031548280000000608770648482518411_",
    className: "st0",
    d: "M100,31.2c-25.6,0-46.4,20.7-46.4,46.4 S74.3,124,100,124s46.4-20.7,46.4-46.4C146.4,52,125.6,31.2,100,31.2 M153.9,76.1c0,32-23.9,49.9-53.9,79.6 c-30.6-29.5-53.9-47-53.9-79.6c0-29.7,24.1-53.9,53.9-53.9C129.7,22.2,153.9,46.4,153.9,76.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83,38.3V117c3.5,1.9,7.2,3.4,11.1,4.1v-87C90.2,35,86.4,36.4,83,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.6,118.5V36.8c-3.4-1.4-7-2.3-10.7-2.7v87C110.6,120.8,114.2,119.9,117.6,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.8,23.6c0,0,7.9-6.5,33.3-11.1s29.7-3.4,29.7-3.4s5.6,0.4,7.4,6.2c0.3,1,0.4,2,0.4,3l0.6,92.4 c0,0,0.1,5.9-6.9,7.3c-4,0-23.4,2.5-29.3,3.8c-5.9,1.2-20.1,4.6-23.8,6.3l-10.9,11c0,0,3.1,1.7,10.7-1.5 c8.1-3.4,32.6-8.7,32.6-8.7s17.3-2,22.8-2.6c5.8-0.7,5.9-1.4,5.9-1.4s7.4-4,8.3-14.4c1-10.3-0.8-94.8-0.8-94.8s-0.1-11.8-16.1-15 C164.7-3,129.6,9,124,11.4s-11.3,5.1-14.1,7.8c-2.6,2.5-2.1,1.9-2.1,1.9S112.8,21.2,118.8,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.2,24c0,0-7.9-6.5-33.3-11.1S18.2,9.5,18.2,9.5s-6.7,0.5-7.8,8l-0.7,93.6c0,0-0.1,5.9,6.9,7.3 c4,0,23.4,2.5,29.3,3.8c5.9,1.2,20.1,4.6,23.8,6.3l10.9,11c0,0-3.1,1.7-10.7-1.5c-8.1-3.4-32.6-8.7-32.6-8.7s-17.3-2-22.8-2.6 c-5.8-0.7-5.9-1.4-5.9-1.4s-7.4-4-8.3-14.4C-0.7,100.4,1,16,1,16S1.1,4.2,17.1,1c18-3.7,53.1,8.3,58.7,10.7s11.3,5.1,14.1,7.8 c2.6,2.5,2.1,1.9,2.1,1.9S87.2,21.7,81.2,24z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMijnStadGemeente);
export default __webpack_public_path__ + "static/media/mijn_stad-gemeente.600dc0e9a2c24f04db4d408e593b28f8.svg";
export { ForwardRef as ReactComponent };